import Alpine from 'alpinejs'

import Freeform from './freeform'
import RepFinderSimple from './repFinderSimple'
import Login from './login'
import MailingList from './mailingList'
import MailingListForm from './mailingListForm'
import DocumentLibrary from './documentLibraryAlgolia'
import WebinarsAlgolia from './webinarsAlgolia'
import Catalog from './catalog'

Alpine.data('freeform', Freeform)
Alpine.data('repFinderSimple', RepFinderSimple)
Alpine.data('login', Login)
Alpine.data('mailingList', MailingList)
Alpine.data('mailingListForm', MailingListForm)
Alpine.data('documentLibrary', DocumentLibrary)
Alpine.data('webinarsAlgolia', WebinarsAlgolia)
Alpine.data('catalog', Catalog)

window.Alpine = Alpine
Alpine.start()
